// bycursor-start
import type { ProductType } from '@/AppGlobal';
import { GenderType } from './billMgmt';
import { BankTypeEnum, BoolString } from './withdrawal';

export type BankInfoCardType = {
  bankCardName?: string; //	银行卡名
  bankCardEnName?: BankTypeEnum; // 银行卡 枚举值名
  bankCardNum1?: string; //	银行卡号
};

export enum BankCardTagType {
  DEFAULT, // 有产品使用
  HANDLING, // 处理中
  UNBINGDING, // 解绑中
  NotDefault, // 不默认
}

export enum DefaultType {
  Default = 'Y',
  NotDefault = 'N',
}

export enum EddaManageState {
  // bycursor-start
  /**
   * bycursor
   * Edda 管理整體流程狀態（EKYC、資料核對、綁定結果等）
   */
  NO_EKYC = 'NO_EKYC', // 未完成 EKYC
  EKYC_SUCCESS = 'EKYC_SUCCESS', // EKYC 成功
  EKYC_PROCESS = 'EKYC_PROCESS', // EKYC 審批/處理中
  EKYC_FAIL = 'EKYC_FAIL', // EKYC 拒絕
  TO_BE_CONFIRM = 'TO_BE_CONFIRM', // 待確認資料
  INFO_VERIFY_PROCESS = 'INFO_VERIFY_PROCESS', // 資料確認/核對中
  INFO_VERIFY_REJECT = 'INFO_VERIFY_REJECT', // 資料核對拒絕
  INFO_VERIFY_COMPLETED = 'INFO_VERIFY_COMPLETED', // 資料核對完成
  CONFIRM = 'CONFIRM', // 確認資料完成,去填写edda页面
  BINDING = 'BINDING', // 綁定中
  SUCCESS = 'SUCCESS', // 綁定成功
  FAIL = 'FAIL', // 綁定失敗
  // bycursor-end
}

// 1 初始化成功  2 初始化失败  3  初始化处理中  4 解绑处理中 5 解绑失败  6解绑成功
export enum BankEddState {
  BindSuccess = '1',
  BindFail = '2',
  BindHandling = '3',
  Unbinding = '4',
  UnbindFail = '5',
  UnbindSuccess = '6',
  Pending = '7', // 外部系統等待中
}

export enum EddaUpdateType {
  AddEdda = '1', // 新增 Edda
  RemoveEdda = '2', // 解绑 Edda
}

export type EddaBankInfo = Partial<{
  state: BankEddState; // 状态
  bankCardCode: string; // 卡ID
  bankCardName: string; // 卡名
  bankCardNumShow: string; // 页面展示银行卡号
  bankCardNumEncrypt: string; // 加密的银行卡号
  isDefault: DefaultType; // 是否默认卡
  amt: number; // 还款金额
  repaymentTime: string; // 最近还款日期
  bankCardEnName: BankTypeEnum; // 英文名
  id: string;
  msgId?: string;
  bankEnNameAbbr: BankTypeEnum;
  mandateId?: string;
  defaultmesgId?: string;
  productList?: { productCode: ProductType }[];
}>;

// Edda 專屬管理返回結果
export type EddaManageResponseDTO = {
  // bycursor-start
  /**
   * bycursor
   * Edda 管理查詢結果資料結構
   */
  id: number; // 主鍵ID
  userId: number; // 用戶ID
  userName: string; // 用戶名
  englishName: string; // 英文名
  idCard: string; // 身份證號碼
  phone: string; // 手機號碼
  email: string; // 郵箱
  sex: GenderType; // 性別
  dateOfBirth: string; // 出生日期
  nationality: string; // 國籍
  nationalityString: string; // 國籍顯示字符串
  state: EddaManageState; // 狀態（NO_EKYC/EKYC_SUCCESS/...）
  reason?: string; // 原因
  productCode?: string; // 產品編碼
  isConfirm?: BoolString; // 是否確認，Y-確認並更新狀態為 CONFIRM
  bankId: string; // 銀行ID（必填）
  bankCardNumEncrypt: string; // 加密卡號（必填）
  bankName: string; // 銀行名（必填）
  bankEnName: string; // 英文銀行名（必填）
  msgId?: string; // 更新默認還款卡必填
  bankNum: string; // 初始化卡號（必填）
  type: number; // 查詢初始化或解绑狀態必填：1 初始化，2 解绑（iOS：1 逾期，2 Edda）
  mandateId?: string; // 解绑必填授權ID
  idNum?: string; // 身份證號
  orderId?: string; // 訂單ID
  bindingType?: 'USER' | 'PAY'; // Edda 綁定方式
  productLabel?: string; // 產品標籤
  // bycursor-end
};
// bycursor-end

// Contains cursor-generated edits.
